import arrowLeft from '~/assets/icons/arrow_left.svg';
import { playSound, Sound } from '~/assets/sounds';
import { Text } from '~/components/ui/Text';
import {
	StyledButton,
	StyledContainer,
	StyledValueContainer,
} from './CountPicker.styled';

const CountPicker = ({
	value,
	onChange,
	disabled,
	min = 1,
	max = 99,
	placeholder = 'шт.',
}: {
	value: number;
	onChange: (value: number) => void;
	disabled: boolean;
	min: number;
	max: number;
	placeholder?: string;
}) => {
	const handleButtonClick = (direction: 'left' | 'right') => {
		if (disabled) {
			return;
		}

		if (direction === 'left') {
			if (value > min) {
				onChange(value - 1);
			}
		} else {
			if (value < max) {
				onChange(value + 1);
			}
		}
	};

	return (
		<StyledContainer>
			<StyledButton
				$direction="left"
				$disabled={disabled}
				onClick={() => {
					handleButtonClick('left');
					playSound(Sound.ClickButton);
				}}
				onMouseEnter={() => playSound(Sound.LinkCursor)}
			>
				<img src={arrowLeft} />
			</StyledButton>
			<StyledValueContainer>
				<Text>
					{value} <span>{placeholder}</span>
				</Text>
			</StyledValueContainer>
			<StyledButton
				$direction="right"
				$disabled={disabled}
				onClick={() => {
					handleButtonClick('right');
					playSound(Sound.ClickButton);
				}}
				onMouseEnter={() => playSound(Sound.LinkCursor)}
			>
				<img src={arrowLeft} style={{ transform: 'rotate(180deg)' }} />
			</StyledButton>
		</StyledContainer>
	);
};

export { CountPicker };
